import React from 'react';
import type { EstadoPresupuesto } from '@/lib/types';
import { Badge } from '@/components/ui/badge';

const MAP: Record<EstadoPresupuesto, { label: string; cls: string }> = {
  Borrador:  { label: 'Borrador',  cls: 'bg-slate-100 text-slate-600 border-slate-200 hover:bg-slate-100' },
  Enviado:   { label: 'Enviado',   cls: 'bg-blue-100 text-blue-700 border-blue-200 hover:bg-blue-100' },
  Aceptado:  { label: 'Aceptado',  cls: 'bg-emerald-100 text-emerald-700 border-emerald-200 hover:bg-emerald-100' },
  Rechazado: { label: 'Rechazado', cls: 'bg-red-100 text-red-700 border-red-200 hover:bg-red-100' },
};

export function EstadoBadge({ estado }: { estado: EstadoPresupuesto }) {
  const { label, cls } = MAP[estado] ?? MAP.Borrador;
  return (
    <Badge variant="outline" className={`${cls} font-medium text-xs px-2.5 py-0.5`}>
      {label}
    </Badge>
  );
}
